import { i18n, Messages } from '@lingui/core';

import getPlurals from '@rover/shared/js/utils/getPlurals';

const initI18n = (locale: string, messages: Messages): void => {
  i18n.loadLocaleData(locale, { plurals: getPlurals(locale) });
  i18n.load(locale, messages);
  i18n.activate(locale);
};

export default initI18n;
